// extracted by mini-css-extract-plugin
module.exports = {"bg-right-to-left":"CarouselHeader_bg-right-to-left__QI9lv"};